import type { AxiosError, AxiosResponse } from 'axios';

export interface ApiErrorData {
  message: string;
  code?: string;
  details?: string;
  error?: string;
}

export class AppError extends Error {
  public readonly originalError: AxiosError;
  public readonly data: ApiErrorData | undefined;
  public readonly status: number | undefined;

  constructor(axiosError: AxiosError) {
    const responseData = (axiosError.response as AxiosResponse<Partial<ApiErrorData>> | undefined)?.data;
    const errorMessage =
      responseData?.message ?? responseData?.error ?? axiosError.message ?? 'An unexpected error occurred.';
    super(errorMessage);
    this.name = 'AppError';
    this.originalError = axiosError;
    this.data = {
      message: errorMessage,
      code: axiosError.code,
      details: responseData?.details,
      error: responseData?.error,
    };
    this.status = axiosError.response?.status;
  }
}

export const isAppError = (error: unknown): error is AppError => {
  return error instanceof AppError;
};
